import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
// import Spinner from "../../../components/Spinner/Spinner";
import withErrorHandler from "../../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../../store/actions/index";
import HorizontalScroll from "../HorizontalScroll/HorizontalScroll";
import classes from "./Sections.module.css";
import { string_to_slug as slug } from "../../../../store/utility";
import SearchBarAdmin from "../../../../components/FindProduct/SearchBarAdmin/SearchBarAdmin";

class Sections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.plan.id,
      title: this.props.plan.title,
      sequence: this.props.plan.sequence,
      seeAllUrl: this.props.plan.seeAllUrl ? this.props.plan.seeAllUrl : "",
      desc: this.props.plan.desc,
      addworkout: {
        title: "",
        url: "",
        planid: "",
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleEditPlan = this.handleEditPlan.bind(this);
    this.handleDeletePlan = this.handleDeletePlan.bind(this);
  }

  handleChange(e) {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleEditPlan(e, id) {
    e.preventDefault();
    let editedPlan = {
      id: id,
      title: this.state.title,
      sequence: this.state.sequence,
      seeAllUrl: this.state.seeAllUrl,
      desc: this.state.desc,
    };
    // console.log(editedPlan, this.props.plan);
    this.props.onEditPlan(editedPlan, this.props.workouts);
  }

  handleDeletePlan(e, id) {
    e.preventDefault();
    // console.log(id);
    this.props.onDeletePlan(id);
  }

  handleWorkoutChange = (e) => {
    let { name, value } = e.target;
    this.setState({
      addworkout: {
        ...this.state.addworkout,
        planid: this.props.plan.id,
        [name]: value,
      },
    });
  };
  handleAddWorkout = (e) => {
    e.preventDefault();
    let plan = this.props.plan;

    this.props.onAddWorkout(this.state.addworkout, plan);
  };

  render() {
    var plan = this.props.plan;
    return (
      <div className={`container ${classes.HorizontalCarousel}`}>
        <>
          <div className={classes.ItemContainer}>
            <div className={classes.Item}>
              <div style={{ maxHeight: "188px", overflow: "hidden" }}>
                {/* <h5>{plan.title}</h5> */}
                {/* <p>{plan.desc}</p> */}
              </div>
              <div className="d-flex">
                <div>
                  <div className="form-group ">
                    <button
                      className="btn btn-success btn-sm "
                      data-toggle="modal"
                      data-target={`#addWorkout${plan.id}`}
                    >
                      Add Product
                    </button>
                    <button
                      className="btn btn-primary btn-sm m-2"
                      data-toggle="modal"
                      data-target={`#edit${plan.id}`}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-secondary btn-sm m-2"
                      data-toggle="modal"
                      data-target={`#delete${plan.id}`}
                    >
                      Delete
                    </button>

                    {/* --------------------------- Add workout plan Modal Starts -------------------------------- */}
                    <div
                      className="modal fade bd-example-modal-lg "
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="myLargeModalLabel"
                      aria-hidden="true"
                      id={`addWorkout${plan.id}`}
                    >
                      <div
                        className="modal-dialog modal-lg"
                        style={{
                          overflowY: "initial !important",
                        }}
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5
                              className="modal-title"
                              id="exampleModalLongTitle"
                            >
                              Search Products
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div
                            className="modal-body"
                            style={{
                              height: "25rem",
                              overflowY: "auto",
                              backgroundColor: "gray",
                            }}
                          >
                            <section>
                              <SearchBarAdmin
                                redirectSearch="homeSections"
                                plan={plan}
                              />
                            </section>
                            <hr />
                            {/* <div className="row m-2">
                        {this.state.workoutPlan.workouts &&
                          this.state.workoutPlan.workouts.map(
                            (workout, index) => (
                              <div className="card col-sm-12 mt-2" key={index}>
                                <div className="card-body p-1">
                                  <p>
                                    <b> YT title: </b>
                                    {workout.title}
                                  </p>
                                  <p>
                                    <b>YT Url:</b> {workout.url}
                                  </p>
                                  <button
                                    className="btn btn-primary float-right m-2"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      right: 0,
                                    }}
                                    onClick={(e) =>
                                      this.handleRemove(e, workout)
                                    }
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            )
                          )}
                      </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* --------------------------- Add workout plan Modal Ends -------------------------------- */}
                  </div>
                </div>
              </div>

              <div>
                {/* <a
                  style={{ color: "#FF8D1E" }}
                  target="_blank"
                  href={`/workouts/${slug(plan.title)}/${plan.id}`}
                >
                  See All
                </a> */}
                <div>
                  {/* ------------------------------------ Edit Plan Modal starts ------------------------------------*/}
                  <div
                    className="modal fade"
                    id={`edit${plan.id}`}
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="exampleModalLabel">
                            Editing: <b>{plan.title}</b>
                          </h5>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <div className="form-group">
                            <label htmlFor="title" className="col-form-label">
                              Title:
                            </label>
                            <input
                              name="title"
                              type="text"
                              className="form-control"
                              id="title"
                              value={this.state.title}
                              onChange={this.handleChange}
                            />
                          </div>

                          <div className="form-group">
                            <label htmlFor="title" className="col-form-label">
                              Description:
                            </label>
                            <textarea
                              name="desc"
                              type="text"
                              className="form-control"
                              id="desc"
                              value={this.state.desc}
                              onChange={this.handleChange}
                              rows="3"
                            />
                          </div>
                          <div className="form-group">
                            <label
                              htmlFor="sequence"
                              className="col-form-label"
                            >
                              Sequence:
                            </label>
                            <input
                              name="sequence"
                              type="number"
                              min={1}
                              className="form-control"
                              id="sequence"
                              value={this.state.sequence}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label
                              htmlFor="seeAllUrl"
                              className="col-form-label"
                            >
                              SeeAll Url:
                            </label>
                            <input
                              name="seeAllUrl"
                              type="text"
                              className="form-control"
                              id="seeAllUrl"
                              value={this.state.seeAllUrl}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={(e) => this.handleEditPlan(e, plan.id)}
                            disabled={this.props.editBtnLoading}
                          >
                            {this.props.editBtnLoading ? "Saving" : "Save"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* ------------------------------------ Edit Plan Modal ends ------------------------------------*/}

                  {/* ------------------------------------ Delete Plan Modal starts ------------------------------------*/}
                  <div
                    className="modal fade"
                    id={`delete${plan.id}`}
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="exampleModalLabel">
                            Irreversible Operation
                          </h5>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <p>
                            Are you sure you want to delete <b>{plan.title}</b>
                          </p>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={(e) => this.handleDeletePlan(e, plan.id)}
                            disabled={this.props.deleteBtnLoading}
                          >
                            {this.props.deleteBtnLoading
                              ? "Deleting"
                              : "Delete"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* ------------------------------------ Delete Plan Modal ends ------------------------------------*/}

                  {/* <div>
                    <a
                      style={{ color: "#FF8D1E" }}
                      target="_blank"
                      href={`/admin/workouts/${slug(plan.title)}/${plan.id}`}
                    >
                      See All
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          {/* <HorizontalScroll plan={plan} index={this.props.index} /> */}
        </>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.category.categories,
    workouts: state.homeProducts.homeSections,
    editBtnLoading: state.homeProducts.editSectionLoading,
    deleteBtnLoading: state.homeProducts.deleteProductLoading,
    addWorkoutLoading: state.workouts.addWorkoutLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onEditPlan: (editedPlan, actualPlan) =>
      dispatch(actions.editHomeSection(editedPlan, actualPlan)),
    onDeletePlan: (id) => dispatch(actions.deleteHomeSection(id)),
    // onFetchCategory: () => dispatch(actions.fetchCategoryAdmin()),
    onAddWorkout: (workout, plan) =>
      dispatch(actions.onAddWorkout(workout, plan)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(Sections, Axios));
